<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Job details') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({created_at: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <div class="p-3" style="width: 100%; overflow: hidden;">
              <highcharts
                :options="chartOptions">
                </highcharts>
            </div>
            <div style="height: 100%; overflow-x: scroll;">
              <table class="table table-bordered">
                <thead class="thead-fixed">
                  <tr>
                    <th-sort field="title" :value="sort" @input="setSort">{{ $t('Title') }}</th-sort>
                    <th-sort field="status" :value="sort" @input="setSort">{{ $t('Status') }}</th-sort>
                    <th-sort field="openings" :value="sort" @input="setSort">{{ $t('Openings') }}</th-sort>
                    <th-sort field="update_status_date" :value="sort" @input="setSort">{{ $t('Status update date') }}</th-sort>
                    <th-sort field="remuneration" :value="sort" @input="setSort">{{ $t('Remuneration') }}</th-sort>
                    <th-sort field="remuneration_max" :value="sort" @input="setSort">{{ $t('Maximum remuneration') }}</th-sort>
                    <th-sort field="remuneration_period" :value="sort" @input="setSort">{{ $t('Remuneration period') }}</th-sort>
                    <th-sort field="date_open" :value="sort" @input="setSort">{{ $t('Opening date') }}</th-sort>
                    <th-sort field="date_close" :value="sort" @input="setSort">{{ $t('Expected closing date') }}</th-sort>
                    <th-sort field="country" :value="sort" @input="setSort">{{ $t('Country') }}</th-sort>
                    <th-sort field="region" :value="sort" @input="setSort">{{ $t('State') }}</th-sort>
                    <th-sort field="city" :value="sort" @input="setSort">{{ $t('City') }}</th-sort>
                    <th-sort field="neighborhood" :value="sort" @input="setSort">{{ $t('Neighborhood') }}</th-sort>
                    <th-sort field="address" :value="sort" @input="setSort">{{ $t('Address') }}</th-sort>
                    <th-sort field="zipcode" :value="sort" @input="setSort">{{ $t('Zip code') }}</th-sort>
                    <th-sort field="workplace_type" :value="sort" @input="setSort">{{ $t('Workplace type') }}</th-sort>
                    <th-sort field="hiring_manager_name" :value="sort" @input="setSort">{{ $t('Hiring manager') }} / {{ $t('Name') }}</th-sort>
                    <th-sort field="hiring_manager_email" :value="sort" @input="setSort">{{ $t('Hiring manager') }} / {{ $t('E-mail') }}</th-sort>
                    <th-sort field="company.name" :value="sort" @input="setSort">{{ $t('Company') }}</th-sort>
                    <th-sort field="departament.name" :value="sort" @input="setSort">{{ $t('Department') }}</th-sort>
                    <th-sort field="contract.name" :value="sort" @input="setSort">{{ $t('Contract') }}</th-sort>
                    <th-sort field="owner_user.name" :value="sort" @input="setSort">{{ $t('Owner') }}</th-sort>
                    <th-sort field="position_category" :value="sort" @input="setSort">{{ $t('Professional category') }}</th-sort>
                    <th-sort field="experience_level" :value="sort" @input="setSort">Nível</th-sort>
                    <th-sort field="education_degree" :value="sort" @input="setSort">Escolaridade</th-sort>
                    <th-sort field="total_candidates" :value="sort" @input="setSort">{{ $t('Candidates') }}</th-sort>
                    <th-sort field="total_hireds" :value="sort" @input="setSort">{{ $t('Hireds') }}</th-sort>
                    <th-sort field="cancel_reason.name" :value="sort" @input="setSort">{{ $t('Cancel reason') }}</th-sort>
                    <th-sort field="created_at" :value="sort" @input="setSort">{{ $t('Created at') }}</th-sort>
                  </tr>
                </thead>
                <tbody>
                  <ListItem
                    v-for="(item, index) in grid.docs"
                    :key="index"
                    :value="item"></ListItem>
                </tbody>
              </table>
            </div>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>
        
      </filterfy>
    </div>

  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import ListItem from './ListItem'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from '../RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportJobDetails',
  components: {
    highcharts: Chart,
    Filterfy,
    ThSort,
    ListItem,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': this.$t('Status'),
          'target': 'status',
          'resource': 'job_status'
        },
        {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'departament_id',
          'resource': 'departaments'
        },
        {
          'type': 'list',
          'label': this.$t('Owner'),
          'target': 'owner_user_id',
          'resource': 'users'
        }
      ],
      grid: false,
      trend: false
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-created_at'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.created_at === undefined ? defaultDate : this.$route.query.created_at
    },
    chartOptions () {
      if (this.trend) {
        return {
          title: {
            text: 'Postos criados no período'
          },
          yAxis: {
            title: {
              text: null
            }
          },
          xAxis: {
            categories: this.trend.map(v => v.label)
          },
          series: [{
            name: 'Postos',
            data: this.trend.map(v => v.total)
          }]
        }
      }
      return null
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        created_at: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      Promise.all([
        this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reports/job-details', {params: params}),
        this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reports/jobs-trend', {params: params})
      ])
      .then(response => {
        this.grid = response[0].data
        this.trend = response[1].data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/job-details/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportJobDetails/List.vue